import { BoughtList, HouselistNew } from '@/API.ts';

export class Resident {
  listId: string;
  firstName?: string | null;
  lastName?: string | null;
  community?: string | null;
  address?: string | null;

  private constructor(
    listId: string,
    firstName?: string | null,
    lastName?: string | null,
    community?: string | null,
    address?: string | null
  ) {
    this.listId = listId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.community = community;
    this.address = address;
  }

  static deserialize(list: BoughtList | HouselistNew) {
    const listId = list.id;
    const firstName = list.firstName;
    const lastName = list.lastName;
    const community =
      (list as BoughtList).site1 || (list as HouselistNew).communityName;
    const address = list.address;
    return new Resident(listId, firstName, lastName, community, address);
  }
}
